"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'rag.file.indexing_error': 'La indexación del archivo falló. Por favor, inténtelo de nuevo o contacte al soporte si el problema persiste.',
};
